/* eslint-disable no-underscore-dangle */
/* eslint-disable global-require */
import axios from 'axios';
import React, { useEffect, useState, useContext } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { SpinnerDotted } from 'spinners-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/fontawesome-free-solid';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getCookies } from '../../hooks/useCookies';
import { TableContext } from '../../contexts/tableContext';
import styles from '../../commoncss/view.module.scss';
import envValues from '../../enviornment';

function ChangeStatus({ value, reportsId }) {
  const [state, setState] = useState({ value: null, isShowStatus: false, isDisabled: false });
  const handleChnage = (val) => {
    setState({ ...state, isDisabled: true });
    const token = getCookies('Token');
    const headers = {
      'Content-Type': 'application/json; charset=utf-8',
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${token}`,
    };
    const body = { status: val };
    axios
      .post(`${envValues.REACT_APP_API_ENDPOINT}/reports/chnage-status/${reportsId}`, body, {
        headers,
      })
      .then((res) => {
        const response = res.data;
        if (response.success) {
          setState({ ...state, value: val, isShowStatus: false });
        } else {
          setState({ ...state, isDisabled: false });
        }
      })
      .catch(() => setState({ ...state, isDisabled: false }));
  };
  useEffect(() => {
    if (!state.value) setState((prev) => ({ ...prev, value, isShowStatus: value === 'Pending' }));
  }, [value]);
  return (
    <div>
      <Row>
        <Col lg={4}>
          <span>{state.value}</span>
        </Col>
        {state.isShowStatus && (
          <Col lg={4}>
            <Row>
              <Col lg={6}>
                <button
                  type="button"
                  onClick={() => handleChnage('Resolved')}
                  disabled={state.isDisabled}
                >
                  Resolve
                </button>
              </Col>
              <Col lg={6}>
                <button
                  type="button"
                  onClick={() => handleChnage('Ignored')}
                  disabled={state.isDisabled}
                >
                  Ignore
                </button>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </div>
  );
}

const ViewChangeChaplain = React.memo(() => {
  const navigate = useNavigate();
  const { dashboardStyle } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);
  const { formthemeStyle } = useContext(TableContext);
  const { viewformStyle } = useContext(TableContext);
  let chRequestId;
  const params = useParams();
  const token = `Bearer ${getCookies('Token')}`;
  // const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({ loading: true, data: [] });
  let statusCode;
  const dateFormater = (date) => {
    const dateInput = moment(date);
    return dateInput.format('LLL');
  };
  const getUserDetails = async () => {
    axios
      .get(`${envValues.REACT_APP_API_ENDPOINT}/chaplain/change-request/${chRequestId}`, {
        method: 'GET',
        headers: { Authorization: token },
      })
      .then((resp) => {
        statusCode = resp.status;
        return resp;
      })
      .then((res) => {
        if (statusCode === 200) {
          setDetails({ loading: false, data: res.data.data });
          // setLoading(false);
        } else {
          // setLoading(false);
          setDetails({ loading: false });
        }
      })
      .catch((err) => {
        setDetails({ loading: false });
        return err;
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    chRequestId = params.chRequestId;
    getUserDetails();
    setDashboardHeader('Chaplain Change Request Details');
  }, []);
  return (
    <div className={styles[bodyStyle]}>
      <div
        className={styles[dashboardStyle]}
        style={{ height: '100vh' }}
        id={styles.dashboardcont2}
      >
        <div className={styles[formthemeStyle]} id={styles.empdetailssection}>
          <FontAwesomeIcon
            icon={faArrowLeft}
            value="Back"
            onClick={() => {
              navigate(-1);
            }}
            className={styles.arrowback}
          />
          {details.loading ? (
            <SpinnerDotted
              style={{
                left: '50%',
                position: 'relative',
                textAlign: 'center',
                top: '50%',
                color: '#39979d',
              }}
            />
          ) : (
            <Container fluid>
              <Row className="mt-3">
                <Col lg={12} md={12} sm={12}>
                  <div className={styles.detaildiv}>
                    <Row>
                      <Col lg={4}>
                        <div className={styles[viewformStyle]} id={styles.empdiv}>
                          <span className={styles.title}>Reason</span>
                          <p className={styles.empname}>{details.data.reason}</p>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className={styles[viewformStyle]} id={styles.empdiv}>
                          <span className={styles.title}>Description</span>
                          <p className={styles.empname}>{details.data.description}</p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4}>
                        <div className={styles[viewformStyle]} id={styles.empdiv}>
                          <span className={styles.title}>user</span>
                          <p className={styles.empname}>{details.data.user}</p>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className={styles[viewformStyle]} id={styles.empdiv}>
                          <span className={styles.title}>New Chaplain</span>
                          <p className={styles.empname}>{details.data.newChaplain}</p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4}>
                        <div className={styles[viewformStyle]} id={styles.empdiv}>
                          <span className={styles.title}>Previous Chaplain</span>
                          <p className={styles.empname}>{details.data.previousChaplain}</p>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className={styles[viewformStyle]} id={styles.empdiv}>
                          <span className={styles.title}>Time</span>
                          <p className={styles.empname}>{dateFormater(details.data.time)}</p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          )}
        </div>
      </div>
    </div>
  );
});

export default ViewChangeChaplain;

ChangeStatus.propTypes = {
  value: PropTypes.string,
  reportsId: PropTypes.string,
};

ChangeStatus.defaultProps = {
  value: 'Pending',
  reportsId: undefined,
};
